import * as Icons from "lucide-react";
import { HOUSE_RULES, HOST, SAFETY_NOTICE } from "@/data/property";
import { Reveal, MaskLineInView } from "./Reveal";

export default function RulesHost() {
  return (
    <section id="host" data-testid="rules-host-section" className="bg-[#F1E8DA] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-16 lg:gap-20">
        {/* House rules */}
        <div>
          <span className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body">Good to Know</span>
          <h2 className="mt-3 font-display font-semibold text-[#0E2A47] text-4xl md:text-5xl tracking-tight leading-none">
            <MaskLineInView>House rules & policies</MaskLineInView>
          </h2>
          <div className="mt-10 grid sm:grid-cols-2 gap-4">
            {HOUSE_RULES.map((r, i) => {
              const Icon = Icons[r.icon] || Icons.Info;
              return (
                <Reveal key={r.label} delay={(i % 2) * 0.06}>
                  <div data-testid={`rule-${i}`} className="flex items-center gap-4 bg-[#FAFAF8] rounded-lg p-4 border border-[#0E2A47]/5">
                    <Icon size={20} strokeWidth={1.6} className="text-[#1FB6C9] shrink-0" />
                    <span className="font-body text-[#0E2A47]">{r.label}</span>
                  </div>
                </Reveal>
              );
            })}
          </div>

          {/* Child safety notice */}
          <Reveal delay={0.15}>
            <div
              data-testid="safety-notice"
              className="mt-6 rounded-lg border border-amber-500/40 bg-amber-50/60 p-5 flex gap-4"
            >
              <Icons.AlertTriangle size={22} className="text-amber-600 shrink-0 mt-0.5" />
              <div>
                <div className="font-display font-medium text-[#0E2A47]">{SAFETY_NOTICE.title}</div>
                <p className="mt-2 text-sm text-[#0E2A47]/70 font-body leading-relaxed">
                  {SAFETY_NOTICE.body}
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        {/* About the host */}
        <Reveal delay={0.1}>
          <div className="bg-[#0E2A47] relative overflow-hidden rounded-2xl p-8 md:p-12 h-full">
            <div className="grain-overlay" />
            <div className="relative">
              <span className="text-sm uppercase tracking-widest text-[#1FB6C9] font-body">Meet Your Host</span>
              <div className="mt-8 flex items-center gap-5">
                <div className="h-20 w-20 rounded-full bg-[#1FB6C9]/10 border-2 border-[#1FB6C9] flex items-center justify-center">
                  <Icons.BadgeCheck size={30} className="text-[#1FB6C9]" />
                </div>
                <div>
                  <div className="font-display font-semibold text-2xl text-white">{HOST.name}</div>
                  <div className="flex items-center gap-2 text-[#1FB6C9] font-body text-sm mt-1">
                    <Icons.Sparkles size={16} /> {HOST.role}
                  </div>
                </div>
              </div>
              <p className="mt-8 text-white/75 font-body text-lg leading-relaxed">{HOST.bio}</p>
              <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-2 text-sm text-white/70 font-body">
                {HOST.perks.map((p) => (
                  <li key={p} className="flex items-center gap-2">
                    <Icons.Check size={14} className="text-[#1FB6C9] shrink-0" /> {p}
                  </li>
                ))}
              </ul>
              <div className="mt-8 flex items-center gap-2 text-white/60 font-body text-sm">
                <Icons.Clock size={16} className="text-[#1FB6C9]" />
                {HOST.responseTime}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
